<template>
    <el-dialog title="Soumettre à validation" v-loading="loader" :visible.sync="display" width="50%">
        <div class="mb-3">Soumettre à validation les {{ items_selected }} produits selectionnés</div>

        <div v-if='items_already_synchronized.length > 0' class='text-red'>
            <p>Attention, les produits suivants sont déjà en review :</p>
            <ul>
                <li v-for='p in items_already_synchronized'>{{ p.name }}</li>
            </ul>
        </div>

        <div v-if='errors.length > 0' class='text-red'>
            <p>Les produits n'ont pas été envoyés en review. Voici les erreurs à corriger</p>
            <template v-for="errorList in errors">
                <div v-for="error in errorList" v-html="error"></div>
            </template>
        </div>

        <el-form class="formSynchronize" ref="form" :model="form">

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            errors: [],
            form: {
                direction: null
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        items_already_synchronized() {
            return this.selected.filter(v => v.review);
        },
        user() {
            return this.$store.getters['app/user'];
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            var datas = {
                products,
                direction: this.form.direction,
                user_id: this.user.id,
                mode: 'synchronize'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            this.$confirm('Soumettre à validation les produits ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios
                        .post('/products/bulk', datas)
                        .then(r => {
                            this.$refs.form.resetFields();
                            this.display = false;
                        })
                        .catch((errors) => {
                            this.errors = errors.response.data;
                            console.log(this.errors);
                        })
                        .then(() => {
                            this.loader = false;
                        });
                }).catch(()=>{

            })

        }
    }
};
</script>
